import * as dbprovider from '@/modules/wrapper/dataProviderWrapper'
import {
  OpenStreetMapProvider
} from 'leaflet-geosearch'

import {
  mutationNames
} from '@/store/storeKeysettings'

import * as Helper from '@/modules/helper/index'

import * as AppReporting from '@/modules/appReporting/index'
import { ConstPaths } from '@/config/pathConfig'
// export const loadAppConfig = ({
//   commit
// }) => {
//   Vue.axios.get('staticdata/appConfig.json')
//     .then(responce => responce.json())
//     .then(data => {
//       if (data) {
//         commit(mutationNames.SET_APPCONFIG, data)
//       }
//     })
// }

export const loadLocalAppConfigData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalAppConfigData(key)
  if (responce) {
    commit(mutationNames.SET_DESIGN_SETTINGS, responce.DesignSettings)
    commit(mutationNames.SET_START_PAGE, responce.MainMenu)
    commit(mutationNames.SET_SUBSCRIPTIONS_MODULES, responce.Modules)
  }
}

export const loadAppConfig = async({
  commit
}, key) => {
  let responce = await dbprovider.loadAppConfig(key)
  if (responce) {
    commit(mutationNames.SET_DESIGN_SETTINGS, responce.DesignSettings)
    commit(mutationNames.SET_START_PAGE, responce.MainMenu)
    commit(mutationNames.SET_SUBSCRIPTIONS_MODULES, responce.Modules)
  }
}

export const loadLocalTeamData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadTeamLocalData(key)
  if (responce) {
    commit(mutationNames.SET_TEAMDATA, responce)
  }
}

export const loadTeam = async({
  commit
}, key) => {
  let responce = await dbprovider.loadTeamData(key)
  if (responce) {
    commit(mutationNames.SET_TEAMDATA, responce)
  }
}

export const loadRadioStream = async({
  commit
}, key) => {
  let responce = await dbprovider.loadRadioStreamData(key)
  if (Helper.IsValid(responce, true)) {
    commit(mutationNames.ADD_STREAM, responce)
  }
}

export const loadRadioStreamLocalData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadRadioStreamLocalData(key)
  if (Helper.IsValid(responce, true)) {
    commit(mutationNames.ADD_STREAM, responce)
  }
}

export const loadContentPages = async({
  commit
}, key) => {
  let responce = await dbprovider.loadContentPagesData(key)
  if (Helper.IsValid(responce, true)) {
    commit(mutationNames.SET_CONTENT_PAGES, responce)
  }
}

export const loadContentPagesLocalData = async({
  commit
}, key) => { 
  let responce = await dbprovider.loadContentPagesLocalData(key)
  if (Helper.IsValid(responce, true)) {
    commit(mutationNames.SET_CONTENT_PAGES, responce)
  }
}

export const loadImageGalleries = async({
  commit
}, key) => {
  let responce = await dbprovider.loadImageGalleriesData(key)
  if (responce) {
    commit(mutationNames.SET_IMAGEGALLERIE, responce)
  }
}

export const loadModulesImageGalleriesLocalData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadModulesImageGalleriesLocalData(key)
  if (responce) {
    commit(mutationNames.SET_IMAGEGALLERIE, responce)
  }
}

export const loadLocalFormData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadFormLocalData(key)
  //console.log('loadLocalFormData', responce)
  if (responce) {
    commit(mutationNames.SET_FORM, responce)
  }
}

export const loadForm = async({
  commit
}, key) => {
  let responce = await dbprovider.loadFormData(key)
  //console.log('loadForm', responce)
  if (responce) {
    commit(mutationNames.SET_FORM, responce)
  }
}

export const setUserCommentData = async({
  commit
}, keyObject) => {
  commit(mutationNames.SET_USERCOMMENT, keyObject)
}

export const SaveRegiterPageViewEnter = ({
  commit,
  rootGetters
}, payload) => {
  payload.Subscription_Id = rootGetters.Subscription_Id
  AppReporting.RegisterPageViewEnter(payload)
}

// export const SaveRegiterPageViewLeft = async({
//   commit
// }, moduleActivationId) => {
//   AppReporting.RegisterPageViewLeft(moduleActivationId)
// }

export const addUpdateLike = ({
  commit
}, payload) => {
  switch (payload.ContentType) {
    case 1:
      commit(mutationNames.ADD_POSTLIKE, payload)
      break
    case 2:
      commit(mutationNames.ADD_IMAGELIKE, payload)
      break
    case 3:
      commit(mutationNames.ADD_STREAMLIKE, payload)
      break
    default:
      break
  }
}

export const shareInformation = ({
  commit
}, payload) => {
  Helper.InitShare(payload)
}

export const addMyFavorite = ({
  commit
}, payload) => {
  Helper.InitFavorite(payload.Reference_Id, payload.ReferenceParent_Id)
}

export const getMyFavorite = ({
  commit
}, payload) => {
  return Helper.CheckIsFavorite(payload.Reference_Id, payload.ReferenceParent_Id)
}

export const contentPageDetailUrl = ({
  commit
}, payload) => {
  return payload.detialPageName + payload.SubscriptionModuleId + '/' + payload.detailId
}

export const getLocationLatLong = async({
  commit
}, key) => {
  const provider = new OpenStreetMapProvider()
  let responce = await provider.search({
    query: key
  })
  return responce
}

export const showModal = ({
  commit
}, payload) => {

  payload.$f7.dialog.create({
    title: payload.title,
    text: payload.text,
    verticalButtons: true,
    buttons: [
      {
        text: payload.downloadbuttonText,
        bold: true,
        onClick: function() {
          // $this.$f7.alert('You clicked second button!')
          commit(mutationNames.SHOW_APPPREVIEWER_LINK)
        }
      },
      {
        text: payload.buttonText,
        bold: true
        // onClick: function() {
        //   $this.$f7.alert('You clicked first button!')
        // }
      }
    ]
  }).open()


}

export const getUrlfromPls = async({
  commit
}, key) => {
  let responce = await dbprovider.loadRadioStreamURL(key)
  return responce
}

export const loadLocalYoutubeData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadYoutubeLocalData(key)
  if (responce) {
    commit(mutationNames.SET_YOUTUBEDATA, responce)
  }
}

export const loadYoutubeData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadYoutubeData(key)
  if (responce) {
    commit(mutationNames.SET_YOUTUBEDATA, responce)
  }
}

export const getVideoDetailListByChannelId = async ({ rootGetters, commit, dispatch }, patload) => {
  let URL = ''
  if (Helper.IsValid(patload.channelId)) {
    if (Helper.IsValid(patload.nextPageToken)) {
      URL = 'search?part=id,snippet&channelId=' + patload.channelId + '&maxResults=' + rootGetters.YoutubePageSize + '&order=date&pageToken=' + patload.nextPageToken + '&type=video&key=' + rootGetters.YoutubeAuthorizationKey
    }
    else {
      URL = 'search?part=id,snippet&channelId=' + patload.channelId + '&maxResults=' + rootGetters.YoutubePageSize + '&order=date&type=video&key=' + rootGetters.YoutubeAuthorizationKey
    }
    let responce = await dbprovider.loadYoutubeChannelURL(`${ConstPaths.youtubeApiUrl}${URL}`)
    let videoIds = ''
    if (responce && responce.items && responce.items.length > 0) {
      responce.items.length < 25 ? responce.nextPageToken = null : ''
      responce.items.sort(function(a, b) { return new Date(b.snippet.publishedAt)  - new Date(a.snippet.publishedAt) })
      responce.items.forEach(val => {
        videoIds = videoIds + val.id.videoId + ','
      })
      if (Helper.IsValid(videoIds)) {
        // URL = 'videos?part=contentDetails%2Cstatistics%2Cid,snippet&id=' + videoIds + '&key=' + rootGetters.YoutubeAuthorizationKey
        let responceData = await dispatch('getVideoDetailsByVideolId', videoIds)
        if (responceData && responceData.items && responceData.items.length > 0) {
          let videoInfoList = null
          if(Helper.IsValid(patload.nextPageToken)) {
            responceData.items.length < 25 ? responce.nextPageToken = null : ''
            let newitems = rootGetters.YoutubeVideoDetailList.items.concat(responceData.items)
            videoInfoList = {
              ...responce,
              items: newitems
            }
          } else {
            videoInfoList = {
              ...responce,
              items: responceData.items
            }
          }
          commit('SET_YOUTUBE', videoInfoList)
        }
      }
    } else {
      responce ? responce.nextPageToken = null : ''
      let videoInfoList = {
        ...responce,
        items: rootGetters.YoutubeVideoDetailList.items
      }
      commit('SET_YOUTUBE', videoInfoList)
    }
  } else {
    commit('SET_YOUTUBE', null)
  }
}

export const getVideoDetailsByVideolId = async ({ rootGetters, commit }, videoIds) => {
  let URL = 'videos?part=contentDetails%2Cstatistics%2Cid,snippet&id=' + videoIds + '&key=' + rootGetters.YoutubeAuthorizationKey
  let responce = await dbprovider.loadYoutubeChannelURL(`${ConstPaths.youtubeApiUrl}${URL}`)
  return responce
}

export const getVideoCommentListByVideolId = async ({ rootGetters, commit }, patload) => {
  let URL = ''
  if (Helper.IsValid(patload.videoId)) {
    if (Helper.IsValid(patload.nextPageToken)) {
      URL = 'commentThreads?part=snippet,replies&videoId=' + patload.videoId + '&maxResults=100&pageToken=' + patload.nextPageToken + '&key=' + rootGetters.YoutubeAuthorizationKey
    }
    else {
      URL = 'commentThreads?part=snippet,replies&videoId=' + patload.videoId + '&maxResults=100&key=' + rootGetters.YoutubeAuthorizationKey
    }
    let responce = await dbprovider.loadYoutubeChannelURL(`${ConstPaths.youtubeApiUrl}${URL}`)
    commit('SET_YOUTUBECOMMNET', responce)
  } else {
    commit('SET_YOUTUBECOMMNET', null)
  }
}

export const loadLocalRssFeedData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadRssFeedLocalData(key)
  if (responce) {
    commit(mutationNames.SET_RSSFEEDDATA, responce)
  }
}

export const loadRssFeedData = async({
  commit, dispatch
}, key) => {
  let responce = await dbprovider.loadRssFeedData(key)
  if (responce) {
    commit(mutationNames.SET_RSSFEEDDATA, responce)
  }
}

export const getRssFeedUrlData = async({
  commit
}, key) => {
  if (Helper.IsValid(key)) {
    let responce = await dbprovider.loadRssFeedURL(key)
    commit(mutationNames.SET_RSSFEEDLIST, responce)
  } else {
    commit(mutationNames.SET_RSSFEEDLIST, null)
  }
}

export const loadLocalTwitterData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadTwitterLocalData(key)
  if (responce) {
    commit(mutationNames.SET_TWITTERDATA, responce)
  }
}

export const loadTwitterData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadTwitterData(key)
  if (responce) {
    commit(mutationNames.SET_TWITTERDATA, responce)
  }
}

export const loadLocalInstagram = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalInstagram(key)
  if (responce) {
    commit(mutationNames.SET_INSTAGRAM, responce)
  }
}

export const loadInstagram = async({
  commit
}, key) => {
  let responce = await dbprovider.loadInstagram(key)
  if (responce) {
    commit(mutationNames.SET_INSTAGRAM, responce)
  }
}

export const loadLocalFacebook = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalFacebook(key)
  if (responce) {
    commit(mutationNames.SET_FACEBOOK, responce)
  }
}

export const loadFacebook = async({
  commit
}, key) => {
  let responce = await dbprovider.loadFacebook(key)
  if (responce) {
    commit(mutationNames.SET_FACEBOOK, responce)
  }
}

export const loadLocalWebsite = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalWebsite(key)
  if (responce) {
    commit(mutationNames.SET_WEBSITE, responce)
  }
}

export const loadWebsite = async({
  commit
}, key) => {
  let responce = await dbprovider.loadWebsite(key)
  if (responce) {
    commit(mutationNames.SET_WEBSITE, responce)
  }
}

export const loadLocalPdf = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalPdf(key)
  if (responce) {
    commit(mutationNames.SET_PDFMODULEINFO, responce)
  }
}

export const loadPdf = async({
  commit, dispatch
}, key) => {
  let responce = await dbprovider.loadPdf(key)
  if (responce) {
    commit(mutationNames.SET_PDFMODULEINFO, responce)
  }
}

export const loadLocalChatData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalChatData(key)
  if (responce) {
    commit(mutationNames.SET_CHAT_PARENT, responce)
  }
}

export const loadChatData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadChatData(key)
  if (responce) {
    commit(mutationNames.SET_CHAT_PARENT, responce)
  }
  return responce
}

export const loadLocalCustomCodeData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadLocalCustomCodeData(key)
  if (responce) {
    commit(mutationNames.SET_CUSTOMCODE, responce)
  }
}
 
export const loadPDFData = async({
  commit
}, key) => {
  let responce = await dbprovider.loadPDFData(key)
  return responce
}

export const loadCustomCode = async({
  commit
}, key) => {
  let responce = await dbprovider.loadCustomCode(key)
  if (responce) {
    commit(mutationNames.SET_CUSTOMCODE, responce)
  }
}




// WEBPACK FOOTER //
// ./src/store/actions.js